/**
 * The applicant surface.
 *
 * SessionProvider first, because the language provider does not need it but the
 * screens need both; then LangProvider, so that no string reaches an applicant
 * without a Malayalam counterpart.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LangProvider, SessionProvider } from "@ksidc/client";
import { App } from "./App.js";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("No #root element to mount into.");

createRoot(container).render(
  <StrictMode>
    <SessionProvider>
      <LangProvider>
        <App />
      </LangProvider>
    </SessionProvider>
  </StrictMode>,
);
